import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    COLDIRETTI_PREV_GELATE: {
        meta: {
            i18nDescrKey: "coldiretti_prev_gelate",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/prevision/ColdirettiPrevGelate.vue"),
    },
    AGRIMETEO_HIST_EV: {
        meta: {
            i18nDescrKey: "agrimeteo_hist_ev",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/historic/AgrimeteoHistEv.vue"),
    },
    AGRIMETEO_HIST_METEO: {
        meta: {
            i18nDescrKey: "agrimeteo_hist_meteo",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/historic/AgrimeteoHistMeteo.vue"),
    },
    AGRIMETEO_HIST_WC: {
        meta: {
            i18nDescrKey: "agrimeteo_hist_wc",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/historic/AgrimeteoHistWC.vue"),
    },

    AGRIMETEO_HIST_RAD: {
        meta: {
            i18nDescrKey: "agrimeteo_hist_rad",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/historic/AgrimeteoHistRad.vue"),
    },
    AGRIMETEO_HIST_TSUOLO: {
        meta: {
            i18nDescrKey: "agrimeteo_hist_tsuolo",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/historic/AgrimeteoHistTSuolo.vue"),
    },
    AGRIMETEO_HIST_SOMMA_TERMICA: {
        meta: {
            i18nDescrKey: "agrimeteo_hist_somma_termica",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/thermal/AgrimeteoHistSommaTermica.vue"),
    },
    AGRIMETEO_FULL_METEO: {
        meta: {
            i18nDescrKey: "agrimeteo_full_meteo",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/prevision/ColdirettiAgrimeteoPrevMeteo.vue"),
    },
    AGRIMETEO_FULL_EV: {
        meta: {
            i18nDescrKey: "agrimeteo_full_ev",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/prevision/ColdirettiAgrimeteoPrevEv.vue"),
    },
    AGRIMETEO_FULL_RAD: {
        meta: {
            i18nDescrKey: "agrimeteo_full_rad",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/prevision/ColdirettiAgrimeteoPrevRad.vue"),
    },
    AGRIMETEO_FULL_TSUOLO: {
        meta: {
            i18nDescrKey: "agrimeteo_full_tsuolo",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/prevision/ColdirettiAgrimeteoPrevTSuolo.vue"),
    },
    AGRIMETEO_FULL_WC: {
        meta: {
            i18nDescrKey: "agrimeteo_full_wc",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/prevision/ColdirettiAgrimeteoPrevWC.vue"),
    },
    ARBOREEE_HIST_PREV_GELATE: {
        meta: {
            i18nDescrKey: "agrimeteo-hist-critical-temperatures",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/thermal/AgrimeteoHistCriticalTemperatures.vue"),
    },
};

export default globals;
